import { gql } from '@apollo/client';

export const GET_AIMO_PLUS_ELIGIBILITY = gql`
  query ReadAimoPlusEligibility {
    readAimoPlusEligibility
  }
`;
